import React, { useContext, useEffect, useState } from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import { useTheme } from '@mui/material/styles';
import { Box, Container, Grid, Typography } from '@mui/material';
import StyledToggleButtonGroup from '../../eir-mobile-offer-toggle/MobileOfferToggle.styled';
import { PrepayOfferContext } from './prepay.context';
import styles from './styles';

/**
 * @name PrepayMobileOfferToggle - Prepay Mobile offer toggle component
 * @returns {JSX.Element} - Returns Prepay Mobile offer toggle Element
 */
const PrepayMobileOfferToggle = ({ prepaySIM = true }) => {
  const theme = useTheme();
  const style = styles(theme);

  const offersType = ['Prepay SIM', 'Prepay Phones & SIM'];

  const { state, setState } = useContext(PrepayOfferContext);
  const [selectedType, setSelectedType] = useState(prepaySIM ? offersType[0] : offersType[1]);

  /**
   * @function togglePrepaySIMOnly
   * @param {*} event - Handles the toggle event on change
   * @param {string} type - Offer type as Prepay SIM , Prepay Phones &SIM
   */
  const togglePrepaySIMOnly = (event, type) => {
    if (!type) return;
    setSelectedType(type);
    localStorage.setItem('selectedPrepayType', type);

    setState(prev => ({
      ...prev,
      prepaySIM: type === 'Prepay SIM',
    }));
  };
  useEffect(() => {
    const savedType = localStorage.getItem('selectedPrepayType');
    if (savedType) {
      setSelectedType(savedType);
      setState({
        ...state,
        prepaySIM: savedType === 'Prepay SIM',
      });
    } else {
      setSelectedType(prepaySIM ? offersType[0] : offersType[1]);
    }
  }, [selectedType, setState]);

  return (
    <Container sx={{ p: 0 }}>
      <Grid container sx={style.containerToggle}>
        <Box sx={style.toggleButtonsContainer}>
          <StyledToggleButtonGroup
            size='small'
            value={selectedType}
            onChange={togglePrepaySIMOnly}
            exclusive
            selected
            aria-label='prepay_mobile_offer_type'
            sx={style.offerButtons}
            prepaySIM={prepaySIM}
          >
            {offersType.map((type, index) => (
              <ToggleButton
                key={index}
                value={type}
                id={`${type}-btn`}
                sx={{ p: 1, width: '100%' }}
                aria-label={`${type}`}
              >
                <Typography variant='subtitle2' sx={style.mobileOfferName}>
                  {type.split('-')[0]}
                </Typography>
                {type.split('-')[1] && (
                  <Typography variant='subtitle2' sx={style.mobileOfferName}>
                    {` - ${type.split('-')[1]}`}
                  </Typography>
                )}
              </ToggleButton>
            ))}
          </StyledToggleButtonGroup>
        </Box>
      </Grid>
    </Container>
  );
};

PrepayMobileOfferToggle.displayName = 'PrepayMobileOfferToggle';
export default PrepayMobileOfferToggle;
